Namespace.create('cv.Views.Setup').ProfileView = Marionette.LayoutView.extend({
  className: 'view-setup-profile',

  template: cv.Templates['setup/profile/view'],

  events : {
  },

  regions : {
    custom_fields : '#custom-fields'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications: true
  }],

  validation: {
    photo_path : [],
    first_name : [{
        required: 'true',
        msg: "Required"
    }],
    last_name : [{
        required: 'true',
        msg: "Required"
    }]
  },

  templateHelpers: function(){
    return {
      profile_photo_cropper: cv.Templates['global/form/form_upload_profile']({
        label : 'Profile Photo',
        id : 'photo_path',
        photo_default : cv.campaign.get('default_fundraiser_photo')
      })

    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // Save profile will fire before this second one is fired
    this.listenTo(this, 'form:saved', function(){
      cv.project.save({
        user_updated : moment.utc().format('YYYY-MM-DD HH:mm:ss')
      },{
        silent : true,
        patch : true,
        success : function(){
          cv.project.set({
            'user.first_name' : cv.user.get('first_name'),
            'user.last_name' : cv.user.get('last_name')
          },{
            silent: true
          });
          console.log('Redirecting...');

          vent.trigger('setup:next_screen');
        }
      });
    }, this);
    
    console.log('SetupProfileView initialized.');
  },

  onAttach: function(){
    // Change document title
    document.title = 'Setup | Finish Your Profile';

    var customFieldsView = new cv.CustomFieldsFormView({
      values : cv.project.get('custom_values'),
      type : 'user',
      container : this.$('#additional-info')
    });

    // Bind a listener
    this.listenTo(customFieldsView, 'form:saved', function(view){
      cv.project.set('custom_values', view.getValues(),{
        silent: true
      });
    }, this);

    // Link the custom form
    this.trigger('form:link', customFieldsView);
    this.showChildView('custom_fields', customFieldsView);
  }
});
